import { configureStore } from "@reduxjs/toolkit";
import settingsReducer from "./settings";
import i18nReducer from "./i18n";
import orderReducer from "./order";
import analyticsReducer from "./analytics";
import uiReducer from "./ui";
import assetsReducer from "./assets";
import recommendProductReducer from "./recommendProduct";
import toast from "./toast";
import eddReducer from "./edd";
import featureSettingReducer from "./featureSetting";

export default configureStore({
  reducer: {
    settings: settingsReducer,
    assets: assetsReducer,
    i18n: i18nReducer,
    order: orderReducer,
    analytics: analyticsReducer,
    ui: uiReducer,
    recommendProducts: recommendProductReducer,
    toast: toast,
    edd: eddReducer,
    featureSetting: featureSettingReducer,
  },
});
